import paper from 'paper';
import { Path, Tool, Rectangle } from 'paper';
import store from '../store';
import PathStyle from '@/services/PathStyle';
import PathUtils from '../services/PathUtils';
import translation from '../plugins/translation';

const delay = ms => new Promise(res => setTimeout(res, ms));

/* eslint-disable no-undef */

function hitOptions() {
    return {
        segments: true,
        stroke: true,
        curves: true,
        fill: true,
        guide: false,
        tolerance: 8 / store.getters.zoom
    };
}

function initializeSelectingRectangle(event) {
    let selectingRectangle = new Path.Rectangle(
        new Rectangle(event.downPoint, event.point)
    );

    paper.project.layers.view.addChild(selectingRectangle);

    selectingRectangle.name = "selecting rectangle";
    selectingRectangle.removeOnDrag();
    selectingRectangle.removeOnUp();

    PathStyle.selectingRectangle(selectingRectangle);
    return selectingRectangle;
}

function onMouseMove(event) {
    paper.project.getItems({ selected: true }).forEach(item => item.selected = false);

    let item = getHitItem(event);
    if (item) item.selected = true;
}

async function onMouseUp(event) {

    let joinTolerance = 0.00001;

    if(event.event.button > 0) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }

    await delay(1);
    store.dispatch('setLoadingStep', translation('blueprintCleaner.outlineDetect'));

    let items = [];
    if (isClick(event)) {
        let item = getHitItem(event);
        if (item) {
            if (item.closed) {
                items = [item];
            } else {
                let selectedColors = store.getters.selectedColors.split(';');
                let allPaths = paper.project.layers.import.getItems({
                    class: 'Path',
                    strokeColor: color => color == null || selectedColors.indexOf(color.toCSS()) > -1
                });
                items = await PathUtils.expandJoinedItems(item, allPaths, joinTolerance);   
            }
        }
    } else {
        let selectingRectangle = initializeSelectingRectangle(event);
        let allItems = getItemsIn(selectingRectangle);
        let closedShapes = await PathUtils.detectClosedShapes(allItems, joinTolerance);

        items = closedShapes.length > 0 ? closedShapes : allItems;

        selectingRectangle.remove();
    }
    if (items.length > 0) {
        switchIgnored(items);
        await PathUtils.updateBlueprint(paper.project.layers.import, paper.project.layers.blueprint);
        onMouseMove(event);
    } else {
        store.dispatch('setLoadingStep', '');
    }
}

function isClick(event) {
    return event.downPoint == null || event.downPoint.isClose(event.point, hitOptions().tolerance);
}

function switchIgnored(items) {
    if (items == null) return;
    let ignore = items.some(item => item && item.name == 'selected');

    items.forEach(item => {
        if (item) {
            item.name = ignore ? 'ignored' : 'selected';
        }
    })
}

function getItemsIn(rect) {
    let selectedColors = store.getters.selectedColors.split(';');
    return paper.project.layers.import.getItems({
        strokeColor: color => color == null ||  selectedColors.indexOf(color.toCSS()) > -1
    })
        .filter(item => {
            if (item.name == 'selecting rectangle') {
                return false;
            }
            if (item.className == 'Shape' && item.type != 'circle') {
                return false;
            }
            let b = item.bounds;
            let r = rect.bounds;
            if (r.contains(b)) return true;

            if (b.top > r.bottom
                || b.bottom < r.top
                || b.left > r.right
                || b.right < r.left
            ) {
                return false;
            }

            if (item.intersects(rect)) {
                return true;
            }
            return false;
        });
}

function onMouseDrag(event) {
    let selectingRectangle = initializeSelectingRectangle(event);

    paper.project.getItems({selected: true})
        .forEach(item => item.selected = false);
    getItemsIn(selectingRectangle).forEach(item => item.selected = true);

    return;
}

function getHitItem(event) {
    let hitItems = getHitItems(event)
    return hitItems.length > 0 ? hitItems[0] : null;
}

function getHitItems(event) {
    let selectedColors = store.getters.selectedColors.split(';');
    let hitResults = paper.project.layers.import.hitTestAll(event.point, hitOptions());

    if (hitResults == null) {
        return;
    }

    return hitResults
        .filter(r => r.item)
        .map(r => r.item)
        .filter(i => i.layer.name == 'import' && (i.strokeColor == null || selectedColors.indexOf(i.strokeColor.toCSS()) > -1))
        .sort((a, b) => a.length - b.length);
}

export const BlueprintCleaner = new Tool({
    name: 'blueprintcleaner',
    onMouseDrag,
    onMouseMove,
    onMouseUp
});
